export interface SalesReportActionTypes {
  type: SalesReportActions;
  payload?: any;
}

export enum SalesReportActions {
  GET_USER_ACTIVITY_REPORT = "GET_USER_ACTIVITY_REPORT",
  GET_CUSTOMER_ACTIVITY_REPORT = "GET_CUSTOMER_ACTIVITY_REPORT",
  GET_LEAD_ACTIVITY_REPORT = "GET_LEAD_ACTIVITY_REPORT",
  GET_CONSOLIDATED_ACTIVITY_REPORT = "GET_CONSOLIDATED_ACTIVITY_REPORT",
}
